/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useSelector } from "react-redux";
import { forwardRef } from "react";
import { Box } from "@mui/system";

const CommentScopeSelect = forwardRef((props, ref) => {
  const { value, onChange, className, level, comment_heirarchy, disabled } = props;

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  // Filter the hierarchy to include only levels at or above the current level
  const filteredHierarchy = comment_heirarchy.slice(0, comment_heirarchy.indexOf(level) + 1);

  const buildInteractive = () => {
    return filteredHierarchy.map((item) => {
        // Preserve the original text for each level
        switch (item) {
          case "page":
            return (
              <MenuItem key={item} value={item} className="space-x-12">
                Page
              </MenuItem>
            );
          case "section":
            return (
              <MenuItem key={item} value={item} className="space-x-12">
                Section
              </MenuItem>
            );
          case "lesson":
            return (
              <MenuItem key={item} value={item} className="space-x-12">
                Global (Lesson)
              </MenuItem>
            );
          case "course":
            return (
              <MenuItem key={item} value={item} className="space-x-12">
                Global (Course)
              </MenuItem>
            );
        }
      })
  }
  const buildStatic = () => {
    return comment_heirarchy.map((item) => {
        // Preserve the original text for each level
        switch (item) {
          case "page":
            return (
              <MenuItem key={item} value={item} className="space-x-12">
                Page
              </MenuItem>
            );
          case "section":
            return (
              <MenuItem key={item} value={item} className="space-x-12">
                Section
              </MenuItem>
            );
          case "lesson":
            return (
              <MenuItem key={item} value={item} className="space-x-12">
                Global (Lesson)
              </MenuItem>
            );
          case "course":
            return (
              <MenuItem key={item} value={item} className="space-x-12">
                Global (Course)
              </MenuItem>
            );
        }
      })
  }

  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="select-label">Scope</InputLabel>
      <Select
        labelId="select-scope"
        id="scope"
        value={disabled ? level : value}
        label="Scope"
        onChange={handleChange}
        ref={ref}
        classes={{ select: "flex items-center space-x-12" }}
        defaultValue={level}
        disabled={disabled}
      >
        {disabled ? buildStatic() : buildInteractive()}
      </Select>
    </FormControl>
  );
});

export default CommentScopeSelect;
